<template>
    <div>
        <div class="tiles">
            <el-collapse class="formset__list">
                <div v-for="tile, i in form.tiles" class="formset__item">
                    <el-collapse-item :name="i">
                        <template slot="title">
                            <formset-header :label="`${tile.title_pl || 'Nowy kafel'}`"
                                            :items.sync="form.tiles"
                                            :errors="checkForErrors(errors.tiles, [i])"
                                            :index="i"/>
                        </template>
                        <el-form-item label="">
                            <el-tooltip placement="top" effect="light">
                                <div slot="content">
                                    <img src="/static/help/tile.png" alt="">
                                </div>
                                <el-button type="info" size="mini">
                                    <i class="fa fa-question-circle"></i> Pomocnicze informacje dotyczące grafik
                                </el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="Tytuł"
                                      :error="errors.tiles && errors.tiles[i] && errors.tiles[i][addLanguageSuffix('title')]">
                            <el-input v-model="tile[addLanguageSuffix('title')]">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="Kolor tła"
                                      :error="errors.tiles && errors.tiles[i] && errors.tiles[i]['bg_color']">
                            <el-color-picker v-model="tile.bg_color"></el-color-picker>
                        </el-form-item>
                        <el-form-item label="Kolor tekstu"
                                      :error="errors.tiles && errors.tiles[i] && errors.tiles[i]['text_color']">
                            <el-color-picker v-model="tile.text_color"/>
                        </el-form-item>
                        <el-form-item label="Zdjęcie"
                                      :error="errors.tiles && errors.tiles[i] && errors.tiles[i]['image']">
                            <image-input-component v-model="tile.image"/>
                        </el-form-item>
                        <el-form-item label="Przycisk">
                            <link-component v-model="tile.link"
                                            :key="tile.key || tile.id"
                                            :errors="errors.tiles && errors.tiles[i] && errors.tiles[i]['link']">
                            </link-component>
                        </el-form-item>
                    </el-collapse-item>
                </div>
            </el-collapse>
            <el-button @click="addSection"
                       type="primary" class="fluid">
                Dodaj kafel
            </el-button>
        </div>
    </div>
</template>
<script>
    import uniqueId from 'lodash.uniqueid'
    import {Tag} from '@/api'

    export default {
        props: ['form', 'errors'],
        methods: {
            addSection () {
                const blankObject = {
                    key: uniqueId(),
                    link: {}
                }
                if (!Array.isArray(this.form.tiles)) {
                    this.$emit('update:form', {
                        ...this.form,
                        tiles: [
                            blankObject
                        ]
                    })
                } else {
                    this.form.tiles.push(blankObject)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// InformationTilesWidget.vue?2b43c091